var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6.372l1.951,3.92a.67.67,0,0,0,.5.368l4.367.631a.672.672,0,0,1,.445.258.648.648,0,0,1-.071.868L12.632,9.481a.64.64,0,0,0-.19.586l.762,4.318a.662.662,0,0,1-.549.751.726.726,0,0,1-.434-.068L8.327,13.034a.656.656,0,0,0-.625,0l-3.917,2.05a.683.683,0,0,1-.907-.278.667.667,0,0,1-.069-.421l.762-4.318a.662.662,0,0,0-.191-.586L.2,6.417a.662.662,0,0,1,0-.939.766.766,0,0,1,.381-.188L4.943,4.66a.685.685,0,0,0,.5-.368L7.4.372A.66.66,0,0,1,7.782.035.672.672,0,0,1,8.3.071.688.688,0,0,1,8.6.372Z",
    transform: "translate(2 2.421)",
    fill: "none",
    stroke: "#dadada",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star - empty.3ac523c68bd744492273bd7973cc5d0f.svg";
export { ForwardRef as ReactComponent };